import { IconGift, IconTruck, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { DiscountType } from 'typings'
import { IconFormula, IconStar } from '../../../../../icons'
import styles from './styles'

const messages = {
  alert: {
    id: 'admin/promotions.form.conditions.alert.items-reference-price',
  },
}

const ICONS: Partial<Record<DiscountType, JSX.Element>> = {
  [DiscountType.Gift]: <IconGift />,
  [DiscountType.Shipping]: <IconTruck />,
  [DiscountType.Formula]: <IconFormula />,
  [DiscountType.Loyalty]: <IconStar />,
}

type AlertProps = {
  discountType: DiscountType | undefined
  mode: 'order' | 'item'
}

export function ItemsReferencePriceAlert(props: AlertProps) {
  const { discountType, mode } = props

  if (!discountType || discountType === DiscountType.Price) {
    return null
  }

  return (
    <div className={styles.alert} role="alert">
      <span className="icon">{ICONS[discountType]}</span>

      <Text>
        <FormattedMessage
          {...messages.alert}
          values={{
            discountType,
            b: (content) => <Text variant="action1">{content}</Text>,
            mode,
          }}
        />
      </Text>
    </div>
  )
}
